import api from "apis/agent";
import { WebApiRequest, HTTP_POST } from "tools/webservice";

export const agentSearchByTerm = (searchTerm, majorCompanyId, mountedRef, successCallback) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.agentSearch(),
  successCallback: successCallback,
  payload:{ searchTerm: searchTerm, majorCompanyId: majorCompanyId },
  mountedRef,
});
